import {Component} from '@angular/core';
import {MenuComponent} from '@core/modules/layout/components/menu/menu.component';
import {RouterService} from '@shared/services/router.service';
import {Menu} from '@core/modules/layout/interfaces/menu.interface';
import {ModalService} from '@shared/modules/modal/services/modal.service';
import {MenuHorizontalSubmenuComponent} from '@core/modules/layout/components/menu/menu-horizontal/menu-horizontal-submenu/menu-horizontal-submenu.component';

@Component({
  selector: 'app-menu-horizontal',
  templateUrl: './menu-horizontal.component.html',
  styleUrls: [
    '../menu.component.scss',
    './menu-horizontal.component.scss'
  ]
})
export class MenuHorizontalComponent extends MenuComponent {
  constructor(
    private routerService: RouterService,
    private modal: ModalService
  ) {
    super();
  }

  isRouteActive(item: Menu): boolean {
    return this.routerService.isActiveRoute(item.link, !item.children);
  }

  showSubmenu(item: Menu): void {
    this.modal.show(MenuHorizontalSubmenuComponent, {
      class: 'modal-dialog-centered modal-sm',
      ignoreBackdropClick: false,
      initialState: { children: item.children }
    });
  }
}
